import { AncillaryBundleItemType } from '@app/pages/ancillary-bundle-page/ancillary-bundle.enum';

export const ancillaryImg: Record<AncillaryBundleItemType, string> = {
  [AncillaryBundleItemType.CancelForAnyReason]: '3d-calendar',
  [AncillaryBundleItemType.PremiumDisruptionAssistance]: '3d-shield',
  [AncillaryBundleItemType.None]: 'warning',
  [AncillaryBundleItemType.Bundle]: 'protections-bundle',
};

export const nonIncludedAncillaryImg: Record<string, string> = {
  [AncillaryBundleItemType.CancelForAnyReason]: '3d-calendar-disabled',
  [AncillaryBundleItemType.PremiumDisruptionAssistance]: '3d-shield-disabled',
  [AncillaryBundleItemType.None]: 'protections-bundle-disabled',
};

export const ancillaryTitles: Record<string, string> = {
  [AncillaryBundleItemType.CancelForAnyReason]: 'Cancel for any reason',
  [AncillaryBundleItemType.PremiumDisruptionAssistance]: 'Premium Disruption Assistance',
  [AncillaryBundleItemType.Bundle]: 'Full Peace Bundle',
  [AncillaryBundleItemType.None]: 'None, I prefer to risk it',
};

export const ancillaryDescriptions: Record<string, string> = {
  [AncillaryBundleItemType.CancelForAnyReason]:
    "Experience ultimate flexibility with our Cancel for any reason. Whether your plans change unexpectedly or you simply decide not to travel, our CFAR option ensures you're covered.",
  [AncillaryBundleItemType.PremiumDisruptionAssistance]:
    'Flight delays, cancellations, or schedule changes can disrupt your plans. Premium Disruption Assistance helps you rebook quickly or get a refund, so you can stay on track with minimal stress.',
};

export const ancillaryNonIncludedDescription: Record<string, string> = {
  [AncillaryBundleItemType.CancelForAnyReason]:
    "You're covered for disruptions, but not if your plans change. Add cancel for any reason and get peace of mind — even if you cancel last minute.\n" +
    '<br />' +
    '<p>&nbsp;</p>' +
    'Get full protection with:',
  [AncillaryBundleItemType.PremiumDisruptionAssistance]:
    "You're covered if you cancel, but not if your flight changes. Add premium disruption assistance and stay protected from delays, cancellations, or missed connections.\n" +
    '<br />' +
    '<p>&nbsp;</p>' +
    'Get full protection with:',
  [AncillaryBundleItemType.None]:
    'Skipping protection means covering all changes or cancellations out of pocket.',
};

export const generateAncillaryNonIncludedTitle = (type: AncillaryBundleItemType) => {
  if (type === AncillaryBundleItemType.None) {
    return 'Are you sure you want to proceed without any protection?';
  }

  return "You're only halfway covered";
};
